import { FC } from 'react'
import { ChipOnBAB } from './ChipOnBAB'
import { ContainerBAB, StyledBet } from './styles'

export const Bet: FC<{
  selected: boolean
  amount: number
}> = ({ selected, amount }) => {
  return (
    <ContainerBAB selected={selected} data-cy="rp-bet-btn">
      <StyledBet selected={selected} />
      {amount > 0 && <ChipOnBAB amount={amount} />}
    </ContainerBAB>
  )
}
